export enum RelationGroup {
  USER = 0,
  VENDOR = 100,
  CUSTOMER = 200,
  STAFF = 300,
  EMPLOYER = 400,
}
